import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Switch } from '@/components/ui/switch';
import { Label } from '@/components/ui/label';
import { Brain } from 'lucide-react';
import { useState } from 'react';

export const QuizSettings = () => {
  const [enabled, setEnabled] = useState(true);

  return (
    <Card>
      <CardHeader>
        <div className="flex items-center gap-2">
          <Brain className="w-5 h-5 text-primary" />
          <CardTitle>Quiz</CardTitle>
        </div>
        <CardDescription>
          Konfigurer quiz-generering og vanskelighetsgrad
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="flex items-center justify-between">
          <Label htmlFor="quiz-enabled">Aktivert</Label>
          <Switch
            id="quiz-enabled"
            checked={enabled}
            onCheckedChange={setEnabled}
          />
        </div>

        <div className="space-y-2">
          <Label>AI-generering</Label>
          <p className="text-sm text-muted-foreground">
            Tilpass hvordan Kai lager quiz-spørsmål basert på artikkelinnhold.
          </p>
        </div>

        <div className="pt-4 border-t">
          <Button>Lagre innstillinger</Button>
        </div>
      </CardContent>
    </Card>
  );
};
